(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordan-acoustic-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elementName = 'nordan-acoustic-comparison';
    if (customElements.get(elementName)) return;

    class NordanAcousticComparison extends HTMLElement {
      connectedCallback() {
        if (this.isInitialized) return;

        this.abortController = new AbortController();
        this.player = this.querySelector('[data-audio-player]');
        this.playButton = this.querySelector('[data-play-button]');
        this.switchButton = this.querySelector('[data-comparison-switch]');
        this.beforeLabel = this.querySelector('[data-before-label]');
        this.afterLabel = this.querySelector('[data-after-label]');
        this.status = this.querySelector('[data-status]');
        this.canvasBefore = this.querySelector('[data-wave-canvas-before]');
        this.canvasAfter = this.querySelector('[data-wave-canvas-after]');
        this.ctxBefore = this.canvasBefore?.getContext('2d');
        this.ctxAfter = this.canvasAfter?.getContext('2d');

        this.isPlaying = false;
        this.isAfter = false;
        this.waveFrame = null;
        this.syncFrame = null;

        // 获取音频元素（只使用 audioBefore 作为播放器）
        this.audioBefore = this.querySelector('[data-audio-before]');
        this.audioAfter = this.querySelector('[data-audio-after]');
        if (!this.audioBefore || !this.audioAfter) return;

        // 保存两个音频 URL
        this.beforeUrl = this.audioBefore.src || this.audioBefore.dataset.src || '';
        this.afterUrl = this.audioAfter.src || this.audioAfter.dataset.src || '';

        // 设置 audioBefore 的初始 src
        this.audioBefore.src = this.beforeUrl;
        // 添加 crossorigin（如果 HTML 中已经加，这里也可以不用）
        this.audioBefore.crossOrigin = 'anonymous';

        this.audioCtx = null;
        this.analyser = null;
        this.gainNode = null;
        this.source = null;
        this.dataArray = null;

        const configuredOutputVolume = Number.parseFloat(this.dataset.audioOutputVolume);
        this.audioOutputVolume = Number.isFinite(configuredOutputVolume)
          ? Math.min(100, Math.max(0, configuredOutputVolume))
          : 100;

        if (!this.playButton || !this.switchButton) return;

        this.initialPlayLabel = this.playButton.getAttribute('aria-label') || 'Play acoustic comparison';

        // 初始化 Canvas 尺寸
        if (this.canvasBefore) { this.canvasBefore.width = 360; this.canvasBefore.height = 64; }
        if (this.canvasAfter) { this.canvasAfter.width = 360; this.canvasAfter.height = 64; }

        // 初始化 Web Audio（只初始化一次，连接 audioBefore）
        this.initWebAudio();

        // 绘制初始静音波形
        this.drawSilent('before');
        this.drawSilent('after');

        // 绑定事件
        const signal = this.abortController.signal;
        this.playButton.addEventListener('click', () => this.togglePlayback(), { signal });
        this.switchButton.addEventListener('click', () => this.toggleComparison(), { signal });

        this.audioBefore.addEventListener('ended', () => this.finishPlayback(), { signal });

        this.updateComparisonState(false);
        this.updateProgress(0);
        this.isInitialized = true;
      }

      disconnectedCallback() {
        this.abortController?.abort();
        this.stopAll();
        if (this.audioCtx && this.audioCtx.state !== 'closed') {
          this.audioCtx.close();
        }
        this.isInitialized = false;
      }

      initWebAudio() {
        try {
          this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
          this.analyser = this.audioCtx.createAnalyser();
          this.analyser.fftSize = 512;
          this.analyser.smoothingTimeConstant = 0.8;
          this.gainNode = this.audioCtx.createGain();
          this.gainNode.gain.setValueAtTime(this.audioOutputVolume / 100, this.audioCtx.currentTime);
          this.dataArray = new Uint8Array(this.analyser.fftSize);

          // 连接 audioBefore 到 analyser（只连接一次）
          this.source = this.audioCtx.createMediaElementSource(this.audioBefore);
          this.source.connect(this.analyser);
          this.analyser.connect(this.gainNode);
          this.gainNode.connect(this.audioCtx.destination);
        } catch (error) {
          console.warn('[NordanAcousticComparison] Web Audio init failed:', error);
        }
      }

      getActiveUrl() {
        return this.isAfter ? this.afterUrl : this.beforeUrl;
      }

      // ---- 绘制波形（基于 Analyser） ----
      drawWaveFromAnalyser(ctx, canvas) {
        if (!this.analyser || !ctx || !canvas || !this.dataArray) return;

        const width = canvas.width;
        const height = canvas.height;
        const midY = height / 2;

        try {
          this.analyser.getByteTimeDomainData(this.dataArray);
          ctx.clearRect(0, 0, width, height);

          const color = this.isAfter ? '#2E7D5E' : '#C44A4A';
          const scale = this.isAfter ? 0.6 : 1.0;

          ctx.beginPath();
          for (let i = 0; i < this.dataArray.length; i++) {
            const x = (i / this.dataArray.length) * width;
            const normalized = (this.dataArray[i] - 128) / 128;
            const y = midY + normalized * (height * 0.42 * scale);
            if (i === 0) ctx.moveTo(x, y);
            else ctx.lineTo(x, y);
          }
          ctx.strokeStyle = color;
          ctx.lineWidth = 2;
          ctx.stroke();

          ctx.beginPath();
          for (let i = 0; i < this.dataArray.length; i++) {
            const x = (i / this.dataArray.length) * width;
            const normalized = (this.dataArray[i] - 128) / 128;
            const y = midY + normalized * (height * 0.42 * scale);
            if (i === 0) ctx.moveTo(x, y);
            else ctx.lineTo(x, y);
          }
          ctx.lineTo(width, midY);
          ctx.lineTo(0, midY);
          ctx.closePath();
          ctx.fillStyle = color + '26';
          ctx.fill();
        } catch (error) {}
      }

      drawSilent(mode) {
        const isBefore = mode === 'before';
        const ctx = isBefore ? this.ctxBefore : this.ctxAfter;
        const canvas = isBefore ? this.canvasBefore : this.canvasAfter;
        if (!ctx || !canvas) return;

        const width = canvas.width;
        const height = canvas.height;
        const midY = height / 2;
        const color = isBefore ? '#C44A4A' : '#2E7D5E';

        ctx.clearRect(0, 0, width, height);
        ctx.beginPath();
        ctx.moveTo(0, midY);
        ctx.lineTo(width, midY);
        ctx.strokeStyle = color;
        ctx.lineWidth = 1.5;
        ctx.stroke();
      }

      startWaveAnimation() {
        if (this.waveFrame) cancelAnimationFrame(this.waveFrame);

        const activeCanvas = this.isAfter ? this.canvasAfter : this.canvasBefore;
        const activeCtx = this.isAfter ? this.ctxAfter : this.ctxBefore;
        const inactiveCanvas = this.isAfter ? this.canvasBefore : this.canvasAfter;
        const inactiveCtx = this.isAfter ? this.ctxBefore : this.ctxAfter;

        if (inactiveCtx && inactiveCanvas) {
          inactiveCtx.clearRect(0, 0, inactiveCanvas.width, inactiveCanvas.height);
        }

        if (!activeCtx || !activeCanvas) return;

        const animate = () => {
          if (!this.isPlaying) {
            this.waveFrame = null;
            return;
          }
          this.drawWaveFromAnalyser(activeCtx, activeCanvas);
          this.waveFrame = requestAnimationFrame(animate);
        };
        this.waveFrame = requestAnimationFrame(animate);
      }

      stopWaveAnimation() {
        if (this.waveFrame) {
          cancelAnimationFrame(this.waveFrame);
          this.waveFrame = null;
        }
      }

      // ---- 播放控制 ----
      async togglePlayback() {
        if (this.isPlaying) {
          this.pausePlayback();
          return;
        }

        const audio = this.audioBefore;
        if (!audio) return;

        // 设置正确的 src
        const url = this.getActiveUrl();
        if (!url) return;

        try {
          // 如果 src 变化，需要 load
          if (audio.src !== url) {
            audio.src = url;
            audio.load();
            // 等待 load 完成
            await new Promise((resolve) => {
              if (audio.readyState >= 2) resolve();
              else audio.addEventListener('loadeddata', resolve, { once: true });
            });
          }

          // 确保 AudioContext 是运行状态
          if (this.audioCtx && this.audioCtx.state === 'suspended') {
            await this.audioCtx.resume();
          }

          // 播放
          await audio.play();

          this.isPlaying = true;
          this.player?.setAttribute('data-playing', 'true');
          this.updatePlayButton();

          this.startWaveAnimation();
          this.startSyncLoop();

        } catch (error) {
          console.warn('Playback start failed:', error);
          if (error.name === 'NotAllowedError') {
            if (this.status) {
              this.status.textContent = 'Please interact with the page first to play audio.';
            }
          } else {
            this.handlePlaybackError();
          }
        }
      }

      pausePlayback() {
        if (this.audioBefore) this.audioBefore.pause();
        this.isPlaying = false;
        this.player?.setAttribute('data-playing', 'false');
        this.updatePlayButton();
        this.stopWaveAnimation();
        this.cancelSyncFrame();
        const mode = this.isAfter ? 'after' : 'before';
        this.drawSilent(mode);
        const inactiveMode = this.isAfter ? 'before' : 'after';
        this.drawSilent(inactiveMode);
      }

      finishPlayback() {
        this.isPlaying = false;
        this.player?.setAttribute('data-playing', 'false');
        this.updatePlayButton();
        this.stopWaveAnimation();
        this.cancelSyncFrame();
        this.updateProgress(0);
        const mode = this.isAfter ? 'after' : 'before';
        this.drawSilent(mode);
        const inactiveMode = this.isAfter ? 'before' : 'after';
        this.drawSilent(inactiveMode);
        this.player?.style.setProperty('--nordan-acoustic-progress', '0%');
      }

      // ---- 切换 ----
      toggleComparison() {
        const wasPlaying = this.isPlaying;
        if (wasPlaying) {
          this.pausePlayback();
        }

        this.isAfter = !this.isAfter;
        this.updateComparisonState(true);

        // 更新播放头颜色
        this.player?.setAttribute('data-active-comparison', this.isAfter ? 'after' : 'before');

        // 重置进度
        this.player?.style.setProperty('--nordan-acoustic-progress', '0%');

        // 如果之前正在播放，重新开始
        if (wasPlaying) {
          // 先确保 audio 的 src 已更新
          const url = this.getActiveUrl();
          if (this.audioBefore && this.audioBefore.src !== url) {
            this.audioBefore.src = url;
            this.audioBefore.load();
          }
          // 延迟一帧再播放
          requestAnimationFrame(() => {
            this.togglePlayback();
          });
        } else {
          // 更新静音波形
          const mode = this.isAfter ? 'after' : 'before';
          this.drawSilent(mode);
          const inactiveMode = this.isAfter ? 'before' : 'after';
          this.drawSilent(inactiveMode);
        }
      }

      updateComparisonState(announce) {
        this.switchButton?.setAttribute('aria-checked', String(this.isAfter));
        this.beforeLabel?.setAttribute('data-active', String(!this.isAfter));
        this.afterLabel?.setAttribute('data-active', String(this.isAfter));

        if (announce && this.status) {
          this.status.textContent = this.isAfter
            ? this.afterLabel?.textContent.trim() || 'With acoustic panels'
            : this.beforeLabel?.textContent.trim() || 'No acoustic panels';
        }
        this.player?.setAttribute('data-active-comparison', this.isAfter ? 'after' : 'before');
      }

      // ---- 进度同步 ----
      startSyncLoop() {
        this.cancelSyncFrame();

        const update = () => {
          if (!this.isPlaying) {
            this.syncFrame = null;
            return;
          }
          const audio = this.audioBefore;
          if (audio && audio.duration) {
            const progress = audio.currentTime / audio.duration;
            this.player?.style.setProperty('--nordan-acoustic-progress', `${Math.min(progress, 1) * 100}%`);
          }
          this.syncFrame = requestAnimationFrame(update);
        };
        this.syncFrame = requestAnimationFrame(update);
      }

      cancelSyncFrame() {
        if (this.syncFrame) {
          cancelAnimationFrame(this.syncFrame);
          this.syncFrame = null;
        }
      }

      updateProgress(currentTime) {
        // not used
      }

      // ---- 辅助 ----
      updatePlayButton() {
        this.playButton?.setAttribute(
          'aria-label',
          this.isPlaying ? 'Pause acoustic comparison' : this.initialPlayLabel
        );
      }

      handlePlaybackError() {
        this.isPlaying = false;
        this.player?.setAttribute('data-playing', 'false');
        this.updatePlayButton();
        this.stopWaveAnimation();
        this.cancelSyncFrame();
        if (this.status) {
          this.status.textContent = 'The audio comparison could not be played.';
        }
        const mode = this.isAfter ? 'after' : 'before';
        this.drawSilent(mode);
        const inactiveMode = this.isAfter ? 'before' : 'after';
        this.drawSilent(inactiveMode);
      }

      stopAll() {
        if (this.audioBefore) this.audioBefore.pause();
        this.isPlaying = false;
        this.player?.setAttribute('data-playing', 'false');
        this.updatePlayButton();
        this.stopWaveAnimation();
        this.cancelSyncFrame();
      }
    }

    customElements.define(elementName, NordanAcousticComparison);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordan-product-carousel"] && !Shopify.designMode) return;
  try {
    
  // Keep the theme's dragging and editor lifecycle. These local controls advance
  // one card and use scroll boundaries, rather than the core's page-sized step.
  class NordanProductCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('slideshow-slides');
      if (!this.track) return;
      this.abortController = new AbortController();
      const options = { signal: this.abortController.signal };
      this.addEventListener('click', this.handleClick, options);
      this.track.addEventListener('scroll', this.updateControls, { ...options, passive: true });
      this.resizeObserver = new ResizeObserver(this.updateControls);
      this.resizeObserver.observe(this.track);
      this.updateControls();
    }

    disconnectedCallback() {
      this.abortController?.abort();
      this.resizeObserver?.disconnect();
    }

    updateControls = () => {
      const track = this.track;
      if (!track) return;
      const maximum = Math.max(0, track.scrollWidth - track.clientWidth);
      const position = Math.abs(track.scrollLeft);
      const previous = this.querySelector('[data-carousel-step="-1"]');
      const next = this.querySelector('[data-carousel-step="1"]');
      const arrows = this.querySelector('[data-carousel-arrows]');
      if (previous) previous.disabled = position <= 2;
      if (next) next.disabled = position >= maximum - 2;
      if (arrows) arrows.hidden = maximum <= 2;
    };

    handleClick = (event) => {
      const button = event.target.closest('[data-carousel-step]');
      if (!button || button.disabled || !this.contains(button)) return;
      const track = this.track;
      const slide = track?.querySelector('.nordan-product-carousel__slide');
      if (!track || !slide) return;
      const trackStyle = getComputedStyle(track);
      const gap = parseFloat(trackStyle.columnGap) || 0;
      const direction = trackStyle.direction === 'rtl' ? -1 : 1;
      track.scrollBy({
        left: (slide.getBoundingClientRect().width + gap) * Number(button.dataset.carouselStep) * direction,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      });
    };
  }

  if (!customElements.get('nordan-product-carousel')) {
    customElements.define('nordan-product-carousel', NordanProductCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nordan-sizing-dimensions"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const elementName = 'nordan-sizing-dimensions';

    if (customElements.get(elementName)) return;

    class NordanSizingDimensions extends HTMLElement {
      connectedCallback() {
        if (this.isInitialized) return;

        this.tabs = Array.from(this.querySelectorAll('[data-size-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-size-panel]'));
        this.specifications = Array.from(this.querySelectorAll('[data-specification]'));
        this.grid = this.querySelector('.nordan-sizing-dimensions__grid');
        this.panelContainer = this.querySelector('[data-size-content]');
        this.media = this.querySelector('[data-size-media]');
        this.specificationsRegion = this.querySelector('[data-specifications]');
        this.specificationsEmpty = this.querySelector('[data-specifications-empty]');
        this.handleClick = this.handleClick.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);

        this.addEventListener('click', this.handleClick);
        this.addEventListener('keydown', this.handleKeydown);
        this.addEventListener('shopify:block:select', this.handleBlockSelect);

        const initialSize = this.dataset.initialSize || this.tabs[0]?.dataset.size || 'size_1';
        this.activate(initialSize);
        this.isInitialized = true;
      }

      disconnectedCallback() {
        if (!this.isInitialized) return;

        this.removeEventListener('click', this.handleClick);
        this.removeEventListener('keydown', this.handleKeydown);
        this.removeEventListener('shopify:block:select', this.handleBlockSelect);
        this.isInitialized = false;
      }

      handleClick(event) {
        const tab = event.target.closest('[data-size-tab]');
        if (!tab || !this.contains(tab)) return;

        this.activate(tab.dataset.size);
      }

      handleBlockSelect(event) {
        const specification = event.target.closest('[data-specification]');
        if (!specification || !this.contains(specification)) return;
        const size = specification.dataset.appliesTo;
        if (size === 'size_1' || size === 'size_2') this.activate(size);
      }

      handleKeydown(event) {
        const tab = event.target.closest('[data-size-tab]');
        if (!tab || !this.contains(tab) || this.tabs.length < 2) return;

        const currentIndex = this.tabs.indexOf(tab);
        let nextIndex = currentIndex;

        switch (event.key) {
          case 'ArrowLeft':
            nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
            break;
          case 'ArrowRight':
            nextIndex = (currentIndex + 1) % this.tabs.length;
            break;
          case 'Home':
            nextIndex = 0;
            break;
          case 'End':
            nextIndex = this.tabs.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        const nextTab = this.tabs[nextIndex];
        this.activate(nextTab.dataset.size);
        nextTab.focus();
      }

      activate(size) {
        this.dataset.activeSize = size;

        let activeTab = null;
        this.tabs.forEach((tab) => {
          const isActive = tab.dataset.size === size;
          tab.classList.toggle('is-active', isActive);
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
          if (isActive) activeTab = tab;
        });

        if (this.panelContainer && activeTab) {
          this.panelContainer.setAttribute('aria-labelledby', activeTab.id);
        }

        let activePanel = null;
        this.panels.forEach((panel) => {
          const isActive = panel.dataset.sizePanel === size;
          panel.hidden = !isActive;
          if (isActive) activePanel = panel;
        });

        const hasImage = activePanel?.dataset.hasImage === 'true';
        this.grid?.classList.toggle('nordan-sizing-dimensions__grid--has-image', hasImage);

        if (this.media) {
          this.media.hidden = !hasImage && !this.hasAttribute('data-design-mode');
        }

        let visibleSpecificationCount = 0;
        this.specifications.forEach((specification) => {
          const appliesTo = specification.dataset.appliesTo;
          const isVisible = appliesTo === 'both' || appliesTo === size;
          specification.hidden = !isVisible;
          if (isVisible) {
            visibleSpecificationCount += 1;
            specification.dataset.desktopColumn = String(((visibleSpecificationCount - 1) % 4) + 1);
          } else {
            delete specification.dataset.desktopColumn;
          }
        });

        if (this.specificationsRegion) {
          this.specificationsRegion.hidden =
            visibleSpecificationCount === 0 && !this.hasAttribute('data-design-mode');
        }

        if (this.specificationsEmpty) {
          this.specificationsEmpty.hidden = visibleSpecificationCount > 0;
        }
      }
    }

    customElements.define(elementName, NordanSizingDimensions);
  })();

  } catch(e) { console.error(e); }
})();
})();
